<template>
    <div class="start-recharge-container">

        <!--頂部欄-->
        <div class="top-nav-container" style="position: fixed;top: 0">
            <span class="title-style">儲值</span>
            <span @click="backClick" style="position: absolute;left: 10px">返回</span>
        </div>

        <div @click="jumpDownloadView" class="client-download-container" style="margin-top: 30%">
            <a>下載APP儲值</a>
        </div>

        <div @click="jumpRechargeView" class="client-download-container" style="margin-top: 30px">
            <a>電訊、gash、PayPal在線儲值</a>
        </div>

    </div>
</template>

<script>
export default {
    name: "StartRechargeVue",
    data() {
        return {
            bookId: "",
            chapterId: "",
        };
    },
    methods: {
        //返回
        backClick: function () {
            this.$router.push({
                path: "ChapterDetailVue",
                query: {
                    bookId: this.bookId,
                    chapterId: this.chapterId,
                },
            });
        },

        //跳轉到下載界面
        jumpDownloadView: function () {
            this.$router.push({
                path: "DownloadVue",
            });
        },

        //跳轉到充值界面
        jumpRechargeView: function () {
            fbq("track", "InitiateCheckout");
            this.$router.push({
                path: "CardPayVue",
                query: {
                    vueName: "ChapterDetailVue",
                    bookId: this.bookId,
                    chapterId: this.chapterId,
                },
            });
        },
    },
    created() {
        this.bookId = this.$route.query.bookId;
        this.chapterId = this.$route.query.chapterId;
    },
    mounted() {
        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod
                    ? n.callMethod.apply(n, arguments)
                    : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(
            window,
            document,
            "script",
            "https://connect.facebook.net/en_US/fbevents.js"
        );
        fbq("init", "808700509711911");
        fbq("track", "PageView");
    },
};
</script>

<noscript>
  <img height="1" width="1" style="display:none"
       src="https://www.facebook.com/tr?id=808700509711911&ev=PageView&noscript=1"/>
</noscript>

<style scoped>
.start-recharge-container {
    max-width: 480px;
    margin: 0 auto;
}

.client-download-container {
    text-align: center;
    margin-left: 10%;
    margin-right: 10%;
    display: flex;
    flex-direction: column;
}

.client-download-container a {
    margin-top: 10px;
    height: 30px;
    background-color: firebrick;
    border: none;
    font-size: 16px;
    border-radius: 5px;
    color: white;
    line-height: 30px;
}

.client-download-container a:active {
    background-color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/StartRechargeVue.vue